import axios from 'axios'
import { createPrefix } from 'utils/create-prefix'

export class PreRegistrationPublicService {
  constructor() {
    this.endpoints = {
      ...createPrefix('/pub/pre', {
        registerBeneSelfReg: '/beneficiary',
        registerSponsorSelfReg: '/sponsor',
      }),
      ...createPrefix('/pub/self-register', {
        self: '/',
      }),
    }
  }

  static create() {
    return new PreRegistrationPublicService()
  }

  async createPreRegBenePublic(form) {
    const servicePath = this.endpoints.registerBeneSelfReg()
    const { data } = await axios.post(servicePath, form)
    return data
  }

  async getPreRegBenePublic(token) {
    const servicePath = this.endpoints.self()
    const { data } = await axios.get(`${servicePath}${token}`)
    return data
  }

  async confirmPreRegBenePublic(token, form) {
    const servicePath = this.endpoints.self()
    const { data } = await axios.post(`${servicePath}${token}`, {
      password: form.password,
    })
    return data
  }

  async createPreRegSponsorPublic(form) {
    const servicePath = this.endpoints.registerSponsorSelfReg()
    const { data } = await axios.post(servicePath, form)
    return data
  }

  async getPreRegSponsorPublic(token) {
    const servicePath = this.endpoints.self()
    const { data } = await axios.get(`${servicePath}${token}`)
    return data
  }

  async confirmPreRegSponsorPublic(token, form) {
    const servicePath = this.endpoints.self()
    const { data } = await axios.post(`${servicePath}${token}`, {
      password: form.password,
    })
    return data
  }
}
